import { styled } from '@mui/material'
import ButtonBase from '@mui/material/ButtonBase'

export const Container = styled(ButtonBase)(({ theme }) => ({
  display: 'flex',
  height: theme.size[17],
  padding: `0 ${theme.spacing.L}`,
  gap: theme.spacing.SM,
  borderRadius: theme.radius.S,
  alignItems: 'center',
  justifyContent: 'flex-start',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: theme.palette.background['a-hover-inverse'],
    '.MuiSvgIcon-root': {
      display: 'inline-block',
    },
  },
})) as typeof ButtonBase
